export const updateText = (
  prefix: string,
  item: string | null | undefined,
  suffix = '',
): string => (item ? `${prefix}${item}${suffix}` : '');

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const removeWhitespace = (str: string) => str.replace(/\s/g, '');
